// extracted by mini-css-extract-plugin
export default {"input":"t5QO3"};